import { ExperimentOutlined, ProfileOutlined, RocketOutlined } from '@ant-design/icons';
import React from 'react';

// 9月份不做训练相关功能
export default {
    path: '/model-training',
    code: 'ModelTraining',
    name: '模型训练',
    icon: <ExperimentOutlined />,
    routes: [
      {
        path: '/model-training',
        hideInMenu: true,
        component: './MenuRedirect',
      },
      {
        path: '/model-training/training-task',
        code: 'TrainingTask',
        name: '微调任务',
        icon: <ProfileOutlined />,
        component: './ModelTraining/TrainingTask',
      },
      {
        path: '/model-training/training-task/create',
        code: 'TrainingTaskCreate-Button',
        name: '创建微调任务',
        hideInMenu: true,
        component: './ModelTraining/TrainingTask/Create',
      },
      {
        path: '/model-training/training-task/detail/:id',
        code: 'TrainingTaskDetail-Button',
        name: '微调任务详情',
        hideInMenu: true,
        component: './ModelTraining/TrainingTask/Detail',
      },
      {
        path: '/model-training/training-model',
        code: 'TrainingModel',
        name: '微调模型',
        icon: <RocketOutlined />,
        component: './ModelTraining/TrainingModel',
      },
    ],
  };
